import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.06 10.47L8 7.41664L4.94 10.47L4 9.52997L8 5.52997L12 9.52997L11.06 10.47Z", fill: "white" }));
export default SvgArrowUp;
